import convertCamelStringToDashCase from "./convertCamelStringToDashCase";

const convertCamelKeysToDashCase = (object) =>
  Object.entries(object).reduce(
    (accumulator, [key, value]) => ({
      ...accumulator,
      [convertCamelStringToDashCase(key)]: value
    }),
    {}
  );

export default convertCamelKeysToDashCase;
